<template>
  <b-tabs>
    <b-tab>
      <template slot="title">
        <i class="icon-list"></i>
      </template>
      <b-list-group class="list-group-accent">
        <b-list-group-item
          class="list-group-item-accent-secondary bg-light d-flex justify-content-between align-items-center"
        >
          <span class="font-weight-bold text-muted text-uppercase small">
            Notifications
          </span>
        </b-list-group-item>
        <b-list-group-item
          active-class="activus"
          v-for="(notification, index) in notifyList"
          :key="notification.id"
          :to="GetNotificationLink(notification)"
          :index="index"
          :class="
            'list-group-item-accent-' +
              notification.color +
              ' list-group-item-divider'
          "
        >
          <div v-html="notification.name"></div>
          <small class="text-muted mr-3">
            <i class="icon-calendar"></i>&nbsp;&nbsp;
            {{ notification.createDateTimeUtc | dateHumanReadable }}
          </small>

          <div
            class="content-short small pt-1"
            v-if="notification.shortDescription"
          >
            <p v-html="notification.shortDescription"></p>
          </div>
        </b-list-group-item>
        <!-- <hr class="transparent mx-3 my-0" />
        <b-list-group-item
          class="list-group-item-accent-secondary bg-light text-center font-weight-bold text-muted text-uppercase small"
        >
          Tomorrow
        </b-list-group-item>
        <b-list-group-item
          href="#"
          class="list-group-item-accent-secondary list-group-item-divider"
        >
          <div><strong>New UI Project - deadline</strong></div>
          <small class="text-muted mr-3"
            ><i class="icon-calendar"></i>&nbsp;&nbsp;10 - 11pm</small
          >
          <div class="content-short" v-if="notification.shortDescription">
            <p v-html="notification.shortDescription">
            </p>
          </div>
        </b-list-group-item>
        <b-list-group-item
          href="#"
          class="list-group-item-accent-success list-group-item-divider"
        >
          <div><strong>#10 Startups.Garden</strong> Meetup</div>
          <small class="text-muted mr-3"
            ><i class="icon-calendar"></i>&nbsp; 1 - 3pm</small
          >
          <small class="text-muted"
            ><i class="icon-location-pin"></i>&nbsp; Palo Alto, CA</small
          >
        </b-list-group-item>
        <b-list-group-item
          href="#"
          class="list-group-item-accent-primary list-group-item-divider"
        >
          <div><strong>Team meeting</strong></div>
          <small class="text-muted mr-3"
            ><i class="icon-calendar"></i>&nbsp; 4 - 6pm</small
          >
          <small class="text-muted"
            ><i class="icon-home"></i>&nbsp; creativeLabs HQ</small
          >
          <div class="avatars-stack mt-2">
            <div class="avatar avatar-xs">
              <img
                src="img/avatars/2.jpg"
                class="img-avatar"
                alt="admin@bootstrapmaster.com"
              />
            </div>
            <div class="avatar avatar-xs">
              <img
                src="img/avatars/3.jpg"
                class="img-avatar"
                alt="admin@bootstrapmaster.com"
              />
            </div>
            <div class="avatar avatar-xs">
              <img
                src="img/avatars/4.jpg"
                class="img-avatar"
                alt="admin@bootstrapmaster.com"
              />
            </div>
            <div class="avatar avatar-xs">
              <img
                src="img/avatars/5.jpg"
                class="img-avatar"
                alt="admin@bootstrapmaster.com"
              />
            </div>
            <div class="avatar avatar-xs">
              <img
                src="img/avatars/6.jpg"
                class="img-avatar"
                alt="admin@bootstrapmaster.com"
              />
            </div>
            <div class="avatar avatar-xs">
              <img
                src="img/avatars/7.jpg"
                class="img-avatar"
                alt="admin@bootstrapmaster.com"
              />
            </div>
            <div class="avatar avatar-xs">
              <img
                src="img/avatars/8.jpg"
                class="img-avatar"
                alt="admin@bootstrapmaster.com"
              />
            </div>
          </div>
        </b-list-group-item> -->
      </b-list-group>
      <div class="text-center mt-2 mb-3">
        <b-button variant="primary" size="sm" @click="loadNotifications()">
          Load More
        </b-button>
      </div>
    </b-tab>
  </b-tabs>
</template>

<script>
import moment from 'moment-timezone';
import { dateHumanReadable } from '@/helpers/utils/vueFilters.js';
export default {
  name: 'DefaultAside',
  filters: {
    dateHumanReadable: dateHumanReadable
  },
  computed: {
    notifyList: {
      get() {
        let arr = [];
        arr = this.notificationsList.sort((a, b) =>
          new Date(a.createDateTimeUtc) < new Date(b.createDateTimeUtc)
            ? 1
            : new Date(a.createDateTimeUtc) === new Date(b.createDateTimeUtc)
            ? new Date(a.createDateTimeUtc) > new Date(b.createDateTimeUtc)
              ? 1
              : -1
            : -1
        );
        return arr
          .slice()
          .reverse()
          .reverse();
      },
      set(val) {}
    }
  },
  data() {
    return {
      loadingNotify: false,
      notifyPage: 0,
      notificationsList: [],
      jobsList: [],
      intervalTracker: null
    };
  },
  methods: {
    GetNotificationLink(notification) {
      if(notification.linkToUrl) {
        return notification.linkToUrl;
      } else if(notification.linkToRouter) {
        if(notification.linkToRouter.paramArgs)
          notification.linkToRouter.params = notification.linkToRouter.paramArgs;
        return notification.linkToRouter;
      } else {
        return '';
      }
    },
    toastNotify(notification) {
      const h = this.$createElement;
      setTimeout(() => {
        this.$bvToast.toast(
          notification.shortDescription
            ? h('div', {
                domProps: { innerHTML: notification.shortDescription }
              })
            : '',
          {
            title: notification.name,
            variant:
              notification.color == 'secondary'
                ? 'default'
                : notification.color,
            autoHideDelay: 7000
          }
        );
        this.updateReadSpecific(notification.id);
      }, 200);
    },
    notifyAddedEvent(args) {
      let notific = args.notification;
      if (this.notificationsList.find(a => a.id == notific.id) == null) {
        this.toastNotify(notific);
        this.notificationsList.push(notific);
      }
    },
    updateJobProgress() {
      var now = moment(new Date());
      this.jobsList.forEach(itm => {
        let runTime = itm.nextRunUTC != null ? new Date(itm.nextRunUTC) : false;
        if (runTime) {
          let diff = moment.duration(moment(itm.nextRunUTC).diff(now));
          let diffSecs = diff.asSeconds();
          if (diffSecs < -10) {
            itm.nextRunUTC = moment(runTime)
              .add(itm.intervalMinutes, 'm')
              .toDate();
            diff = moment.duration(moment(itm.nextRunUTC).diff(now));
            diffSecs = diff.asSeconds();
          }
          itm.untilNextPercent =
            100 -
            Math.ceil((parseInt(diffSecs) / (itm.intervalMinutes * 60)) * 100);
        }
      });
    },
    updateReadSpecific(id) {
      this.$http
        .post('/api/common/notifications/update-read/' + id, {})
        .then(resp => {})
        .catch(err => {});
    },
    loadNotifications() {
      this.notifyPage++;
      this.loadingNotify = true;
      this.$http
        .post('/api/common/notifications/list', {
          ...{
            filterSome: ''
          },
          ...{
            page: this.notifyPage,
            perPage: 10
          }
        })
        .then(resp => {
          let itms = resp.data.items;
          let arrs = [];
          itms.forEach(notific => {
            if (this.notificationsList.find(a => a.id == notific.id) == null) {
              arrs.push(notific);
            }
          });
          this.notificationsList = this.notificationsList.concat(arrs);
          this.loadingNotify = false;
        })
        .catch(err => {
          this.loadingNotify = false;
        });
    },
    // loadJobTimes() {
    //   this.$http
    //     .get('/api/jobs-run-times')
    //     .then(resp => {
    //       let itms = resp.data;
    //       itms.forEach(itm => {
    //         itm.untilNextPercent = 0;
    //       });
    //       this.jobsList = itms;
    //       if (this.intervalTracker) {
    //         clearInterval(this.intervalTracker);
    //       }
    //       this.updateJobProgress();
    //       this.intervalTracker = setInterval(() => {
    //         this.updateJobProgress();
    //       }, 20000);
    //     })
    //     .catch(err => {});
    // }
  },
  created: function() {
    this.$userHub.$on('new-notification-added', this.notifyAddedEvent);
  },
  beforeDestroy: function() {
    //clean SignalR event
    this.$userHub.$off('new-notification-added', this.notifyAddedEvent);
  },
  mounted() {
    //this.loadJobTimes();
    this.loadNotifications();
  }
};
</script>
